import React from 'react';
import PropTypes from 'prop-types';

import './UpdateBanner.styles.less';

const UpdateBanner = ({ text }) => (
  <div className="public__update-banner">
    <div>{text}</div>
  </div>
);

UpdateBanner.propTypes = {
  text: PropTypes.string,
};

export default UpdateBanner;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/UpdateBanner/UpdateBanner.jsx